import script from "./CookieModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookieModal.vue?vue&type=script&lang=ts&setup=true"

import "./CookieModal.vue?vue&type=style&index=0&id=5a76c75d&lang=scss&scoped=true"

import exportComponent from "/home/teamcity-agent/agent3/work/1e41b97f3be6577f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a76c75d"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
